export default class UpdateResultadoPersonalC3 {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(idPersonal, idResultado, resultado) {
    return await this.#repository.update(idPersonal, idResultado, resultado)
  }
}
